import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export const formatDate = (from: Date, to = new Date()) => {
    const fromTime = dayjs(from);
    const toTime = dayjs(to);

    const diff = dayjs.duration(toTime.diff(fromTime));

    const years = diff.years();
    const months = diff.months();
    const weeks = diff.weeks();
    const days = diff.days();
    const hours = diff.hours();
    const minutes = diff.minutes();
    const seconds = diff.seconds();

    if (years > 0) {
        return `${years}년 전`;
    } else if (months > 0) {
        return `${months}달 전`;
    } else if (weeks > 0) {
        return `${weeks}주 전`;
    } else if (days > 1) {
        return `${days}일 전`;
    } else if (days === 1) {
        return `어제`;
    } else if (hours > 0) {
        return `${hours}시간 전`;
    } else if (minutes > 0) {
        return `${minutes}분 전`;
    } else if (seconds > 10) {
        return `${seconds}초 전`;
    } else {
        return `방금 전`;
    }
};
